// Definition: Views for the AI Course generation funel
export enum AI_COURSE_VIEWS {
  INITIAL = 'INITIAL',
  LOADING_PLAN = 'LOADING_PLAN',
  LOADING_MICROKNOWLEDGES = 'LOADING_MICROKNOWLEDGES',
  PLAN_VALIDATION = 'PLAN_VALIDATION',
  MICROKNOWLEDGES_VALIDATION = 'MICROKNOWLEDGES_VALIDATION',
}
